'use client';

import { ComponentPropsWithRef, ComponentRef, forwardRef } from 'react';
import { cn } from '@/shared/utils/cn';
import { Label } from '@/shared/components/form/label';
import { useTranslations } from 'next-intl';

export const FieldLabel = forwardRef<
  ComponentRef<typeof Label>,
  ComponentPropsWithRef<typeof Label> & { isRequired?: boolean }
>(({ className, children, isRequired, ...props }, ref) => {
  const t = useTranslations('Form');
  return (
    <Label
      ref={ref}
      className={cn('mb-2 inline-flex w-full items-center justify-between', className)}
      {...props}
    >
      <>
        {children}
        {isRequired && (
          <span className='text-text-muted pl-2 text-xs font-normal'>{t('required')}</span>
        )}
      </>
    </Label>
  );
});
FieldLabel.displayName = 'FieldLabel';
